export default "__VITE_ASSET__B9E13J95__"